import Image from '@/components/UI/Image';
import { formatLink } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { useMemo } from 'react';
export default function SeriesType({ initData }: any) {
    const { Link, isMobile } = useGlobal();
    const Dom = useMemo(() => {
        return (
            <>
                {initData?.map((item: any, itemIndex: number) => (
                    <div className="bottom-content" key={itemIndex}>
                        <div className="bbg">
                            {item.phonePictureUrl && isMobile && (
                                <Image src={item.phonePictureUrl} className="fullImgs" layout="fill" alt={item.mainHeading}></Image>
                            )}
                            {item.webPictureUrl && !isMobile && (
                                <Image src={item.webPictureUrl} className="fullImgs" layout="fill" alt={item.mainHeading}></Image>
                            )}
                        </div>
                        <div className="container ">
                            <div className="box left">
                                <h2
                                    className="title font-family-bold"
                                    style={{
                                        color: item.textColor === 'white' ? '#fff' : '#000',
                                    }}
                                >
                                    {item.mainHeading}
                                </h2>
                                <p
                                    className="subtitle"
                                    style={{
                                        display: item.subHeading ? 'block' : 'none',
                                        color: item.textColor === 'white' ? '#fff' : '#000',
                                    }}
                                >
                                    {item.subHeading}
                                </p>
                                <div className="link">
                                    {JSON.parse(item.buttonText)[0]?.buttonUrl && (
                                        <Link {...formatLink(JSON.parse(item.buttonText)[0].buttonUrl)} ariaLabel={item.mainHeading}>
                                            <span type="link" className="msg-linkitem ef-icon-arrowright" aria-label={item.mainHeading}>
                                                {JSON.parse(item.buttonText)[0].buttonName}
                                            </span>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );
    }, [Image, Link, initData, isMobile]);
    return <>{Dom}</>;
}
